import React, { createContext, useContext, useState, useEffect } from 'react';
import { sendOtp as apiSendOtp, verifyOtp as apiVerifyOtp, adminLogin as apiAdminLogin, registerUser, placeOrder as apiPlaceOrder, fetchOrders } from '../ApiService';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [orders, setOrders] = useState([]);

  // Persist session
  useEffect(() => {
    const savedUser = localStorage.getItem('loggedUser');
    if (savedUser) {
      const parsed = JSON.parse(savedUser);
      setUser(parsed);
      setIsAdmin(parsed.role === 'admin');
    }
  }, []);

  // Fetch orders whenever user changes
  const refreshOrders = async () => {
    if (user) {
      try {
        const res = await fetchOrders(user.id, user.role);
        setOrders(res.data);
      } catch (err) {
        console.error("Failed to fetch orders", err);
      }
    }
  };

  useEffect(() => {
    refreshOrders();
  }, [user]);

  const sendOtp = async (mobile) => {
    try {
      const res = await apiSendOtp(mobile);
      return { success: res.data.status === 'success', message: res.data.message };
    } catch (err) {
      return { success: false, message: "Failed to send OTP" };
    }
  };

  const loginWithOtp = async (mobile, otp) => {
    try {
      const res = await apiVerifyOtp(mobile, otp);
      if (res.data.status === 'success' && res.data.user) {
        const userData = res.data.user;
        setUser(userData);
        setIsAdmin(userData.role === 'admin');
        localStorage.setItem('loggedUser', JSON.stringify(userData));
        return { success: true };
      } else {
        return { success: false, message: res.data.message || "User data not found" };
      }
    } catch (err) {
      console.error("OTP Verification Error:", err);
      return { success: false, message: "Verification failed on server" };
    }
  };

  const adminLogin = async (username, mobile) => {
    try {
      const res = await apiAdminLogin(username, mobile);
      if (res.data.status === 'success') {
        const userData = res.data.user;
        setUser(userData);
        setIsAdmin(true);
        localStorage.setItem('loggedUser', JSON.stringify(userData));
        return { success: true };
      } else {
        return { success: false, message: res.data.message };
      }
    } catch (err) {
      return { success: false, message: "Admin login failed" };
    }
  };

  const logout = () => {
    setUser(null);
    setIsAdmin(false);
    setOrders([]);
    localStorage.removeItem('loggedUser');
  };

  return (
    <AppContext.Provider value={{ user, isAdmin, sendOtp, loginWithOtp, adminLogin, logout, orders, refreshOrders }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
